function floatPrecision(floatValue, precision) {
    const parsedFloatValue = parseFloat(floatValue);
    if (Number.isNaN(parsedFloatValue)) {
        return parseFloat('0').toFixed(precision);
    }
    const power = 10 ** precision;
    const roundedFloatValue = (
        Math.round(parsedFloatValue * power) / power
    ).toFixed(precision);
    return roundedFloatValue.toString();
}

function fileSize(size) {
    if (size > 1024) {
        const kbSize = size / 1024;
        if (kbSize > 1024) {
            const mbSize = kbSize / 1024;
            return `${floatPrecision(mbSize, 2)} MB`;
        }
        return `${Math.round(kbSize)} kB`;
    }
    return `${size} B`;
}

function isFolder(file) {
    return file.key.endsWith('/');
}

export { isFolder, floatPrecision, fileSize };
